module.exports = __webpack_public_path__ + "static/apple_store_badge-255e7e0f5a5763c0b711f79118e36caa.svg";